(function () {

	var buttons = document.querySelectorAll('.social-media-share--copy-url');

	Array.prototype.forEach.call(buttons, function (button) {
		button.addEventListener('click', function() {
			//dummyElement-method is used for IE-compability
			var dummyElement = document.createElement('input'),
			text = button.dataset.url;

			document.body.appendChild(dummyElement);
			dummyElement.value = text;
			dummyElement.select();
			document.execCommand('copy');
			document.body.removeChild(dummyElement);

			button.classList.add('animate');

			setTimeout(function() {
				button.classList.remove('animate');
			}, 400);
		});
	});
})();
